/**
 * The screens a back arrow is allowed to land on.
 *
 * WHY A LIST, AND WHY THIS ONE. The back arrow climbs the address to find the
 * screen above the current one. It has to know which addresses are real pages,
 * because an arrow that navigates to a route nobody declared lands on a blank
 * screen, which is worse than the bug it replaces.
 *
 * WHAT IT IS NOT. Not every route of the application: there are more than
 * eighty-five, spread over sixty-nine files, and a list of all of them would
 * be wrong within a week. This is the much shorter list of screens somebody
 * comes BACK to, which is a different thing and changes far less often. A
 * screen missing from here is not broken: the arrow simply climbs past it to
 * the next one that is listed, and at worst reaches the home screen.
 *
 * `:id` stands for one segment, whatever it contains.
 */
export const SCREENS_TO_COME_BACK_TO = [
  '/home',
  '/home/explore',
  '/home/profile',
  '/home/profile/edit',
  '/home/activity',
  '/home/message',
  '/home/search',
  '/home/notifications',
  '/home/group/:id',
  '/home/member/:id',
  '/home/detail-activity/:id',
  '/auth',
] as const;

/** Whether an address is one of them, with `:id` matching any single segment. */
export const isAScreenToComeBackTo = (
  candidate: string,
  screens: readonly string[] = SCREENS_TO_COME_BACK_TO,
): boolean => {
  const parts = candidate.split('/').filter(Boolean);

  return screens.some((pattern) => {
    const wanted = pattern.split('/').filter(Boolean);
    if (wanted.length !== parts.length) {
      return false;
    }
    return wanted.every((segment, at) => segment === ':id' || segment === parts[at]);
  });
};
